import React, { useCallback, useMemo } from 'react'
import { ChatContextSourceType } from '@trustero/trustero-api-web/lib/chatcontext/chatcontext_pb'
import { ChatContext } from 'src/components/Reusable/ChatContext/useChatContext.hooks'
import { useVendorsPermalink } from 'src/components/PageLayout/Permalink/generatePermalink'
import { ChatContextBooleanSelector } from '../chatContextPanel.components'
import { ExternalLink } from './utils.components'

export type VendorManagementModalProps = {
  show: boolean
  hide: () => void
  onBack?: () => void
  context: ChatContext
  setContext: (context: ChatContext) => void
}

export const VendorManagementModal = ({
  show,
  hide,
  onBack,
  context,
  setContext,
}: VendorManagementModalProps): JSX.Element => {
  const vendorsPermalink = useVendorsPermalink()

  const onCommit = useCallback(
    (includeAll: boolean) => {
      setContext({
        ...context,
        [ChatContextSourceType.VENDORS]: {
          ...context[ChatContextSourceType.VENDORS],
          includeAll,
        },
      })
    },
    [context, setContext],
  )

  const description = useMemo(
    () => (
      <p>
        Select if you want to consider your{' '}
        <ExternalLink to={vendorsPermalink}>vendors</ExternalLink>
      </p>
    ),
    [vendorsPermalink],
  )

  return (
    <ChatContextBooleanSelector
      title="Vendors"
      description={description}
      prompt="Do consider vendors"
      currentSelection={context[ChatContextSourceType.VENDORS].includeAll}
      onCommit={onCommit}
      show={show}
      hide={hide}
      onBack={onBack}
    />
  )
}
